import * as Msal from '../common/msal';
import Utils, { B2CConfiguration, SecurityRoles } from '../common/utils';
import axios from 'axios';

import actionTypes from '../common/actionTypes';
import authAPI from './authAPI';

const authActions = {
	fetchUserSuccess: (user: UserDetails) => {
		return { type: actionTypes.FETCH_USER_AUTH_SUCCESS, user };
	},
	fetchAuthenticatedUser: () => {
		// Utils.B2CConfiguration throws an error if called from the store during startup.
		// if we call this from a page on a button push it works just fine.

		return (dispatch: any, getState: any) => {
			return fetchSignUpUser()
				.catch(() => {
					// because b2c signs tokens differently with different policies 
					// we need to try each to see if the user is logged in  (STUPID)
					return fetchSignUpInUser();
				})
				.catch(() => {
					return fetchSignInUserMultiFactor();
				})
				.then(handleIdToken)
				.then((user: UserDetails) => {
					// the user record comes from b2c and we don't yet have the yolo user id. 
					// get it from the policy as that is what we are linking to.
					const { customerPolicy } = getState().policy;
					user.id = customerPolicy.customerId;
					return linkUserAndAuthRecords(user);
				})
				.then((user: UserDetails) => {
					return dispatch(authActions.fetchUserSuccess(user));
				})
				.then(authAPI.getCurrentUserData)
				.then((user: UserDetails) => {
					return dispatch(authActions.fetchUserSuccess(user));
				})
				.catch((error: any) => {
					if (error !== 'user_login_error:User login is required') {
						dispatch({ type: actionTypes.FETCH_USER_AUTH_FAILURE, error });
						// tslint:disable-next-line
						console.error('failed to fetch loggedin user', error);
					}
				});
		};
	},

	logout: () => {
		return (dispatch: any) => {
			let clientApplication = setupAuthClient();

			clientApplication.logout();
			dispatch({ type: actionTypes.USER_AUTH_LOGOUT });
			return Promise.resolve();
		};
	},
	login: () => {
		return (dispatch: any) => {
			clearMSALSession();
			let clientApplication = setupAuthClient();
			return clientApplication.loginRedirect(B2CConfiguration.b2cScopes);
		};
	},
	loginAdmin: () => {
		return (dispatch: any) => {
			clearMSALSession();
			let clientApplication = setupAuthClient(B2CConfiguration.authoritySignInMultiFactor);
			return clientApplication.loginRedirect(B2CConfiguration.b2cScopes);
		};
	},
	signUp: (redirectUrl: string) => {
		return (dispatch: any) => {
			let authClient = setupAuthClient(B2CConfiguration.authoritySignUp, redirectUrl);
			return authClient.loginRedirect(B2CConfiguration.b2cScopes);
		};
	},
	doneDirect: (currentUser: UserDetails) => { 
		return { type: actionTypes.SET_DIRECT_STATUS_SUCCESS, currentUser };
	},
	setCurrentUserhasSignedIn: (hasSignedIn: boolean) => {
		return { type: actionTypes.SET_CURRENTUSER_HAS_SIGNED_IN, hasSignedIn };
	},
	getResetPasswordUrlForEmail: () => {
		return (dispatch: any) => {
			let url = generateResetPasswordUrl();
			return url;
		};
	}
};

const clearMSALSession = () => {
	let msalKeys: Array<string> = [];
	for (let index = 0; index < window.sessionStorage.length; index++) {
		const key = window.sessionStorage.key(index);
		if (key && key.startsWith('msal')) {
			msalKeys.push(key);
		}
	}

	msalKeys.forEach((key) => window.sessionStorage.removeItem(key));
};
const fetchSignUpInUser = () => {
	let authClient = setupAuthClient();
	return authClient.acquireTokenSilent(B2CConfiguration.b2cScopes);
};
const fetchSignUpUser = () => {
	let authClient = setupAuthClient(B2CConfiguration.authoritySignUp);
	return authClient.acquireTokenSilent(B2CConfiguration.b2cScopes);
};
const fetchSignInUserMultiFactor = () => {
	let authClient = setupAuthClient(B2CConfiguration.authoritySignInMultiFactor);
	return authClient.acquireTokenSilent(B2CConfiguration.b2cScopes);
};
const handleIdToken = (accessToken: any) => {
	// tslint:disable-next-line
	axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

	// msal doesn't currently support custom tokens like the role
	// so we handle it. future version should do this for us
	var claims = Utils.extractIdToken(accessToken);
	// if no roles add the customer role
	const role = claims.extension_Role ? JSON.parse(claims.extension_Role) : [SecurityRoles.Customer];
	const user: UserDetails = {
		role: role,
		fullName: claims.name,
		userId: claims.sub,
		tfp: claims.tfp,
	};

	return user;
};
const linkUserAndAuthRecords = (user: UserDetails) => {
	// if this is a sign up request link the records
	if (user.tfp === B2CConfiguration.policyNameSignUp) {
		return authAPI.linkUserAndAuthRecords(user.id!)
			.then(() => user);
	}
	else {
		return user;
	}
};
const setupAuthClient = (authority?: string, redirect?: string) => {
	let logger = undefined;
	function loggerCallback(logLevel: any, message: any, piiLoggingEnabled: any) {
		// tslint:disable-next-line
		console.log('[msal]', message);
	}
	if (process.env.NODE_ENV === 'development') {
		logger = new Msal.Logger(loggerCallback, { level: Msal.LogLevel.Verbose });
	}

	const msalAuthority = authority ? authority : B2CConfiguration.authoritySignIn;
	const options = {
		postLogoutRedirectUri: window.location.origin,
		redirectUri: redirect ? `${window.location.origin}${redirect}` : `${window.location.origin}/login`,
		navigateToLoginRequestUrl: redirect ? false : true,
		logger: logger
	};
	function SignUpInCallback(errorDesc: any, token: any, error: any, tokenType: any) {
		// Called after loginRedirect or acquireTokenPopup
		// authActions.fetchAuthenticatedUser();
		
		if (errorDesc && errorDesc.startsWith('AADB2C90118')) { // forgot password
			let resetUrl = `${process.env.REACT_APP_B2C_Authority_Reset}`
				+ `&client_id=${process.env.REACT_APP_B2C_ClientID}`
				+ '&nonce=defaultNonce'
				+ `&redirect_uri=${window.location.origin}/login`
				+ '&scope=openid'
				+ '&response_type=id_token'
				+ '&prompt=login';

			window.location.href = resetUrl;
		} 
		else if (token) {
			const claims = Utils.extractIdToken(token);
			if (claims.tfp === B2CConfiguration.policyNameResetPwd) {
				let clientAppLoginAfterPasswordReset = setupAuthClient();
				return clientAppLoginAfterPasswordReset.loginRedirect(B2CConfiguration.b2cScopes);
			} 
			else if (claims.tfp !== B2CConfiguration.policyNameMultiFactor && claims.extension_Role &&
				!JSON.parse(claims.extension_Role).some((r: string) => r === 'Customer')) {
					clearMSALSession();
					authActions.logout();
					window.location.href = `${window.location.origin}/require-multi-factor-login`;
			}
		}
		// tslint:disable-next-line
		console.info('signupin callback ');
	}
	let clientApplication = new Msal.UserAgentApplication(
		B2CConfiguration.clientID,
		msalAuthority,
		SignUpInCallback,
		options
	);
	return clientApplication;
};

const generateResetPasswordUrl = () => {
	let resetUrl = `${process.env.REACT_APP_B2C_Authority_Reset}`
				+ `&client_id=${process.env.REACT_APP_B2C_ClientID}`
				+ '&nonce=defaultNonce'
				+ `&redirect_uri=${window.location.origin}/login`
				+ '&scope=openid'
				+ '&response_type=id_token'
				+ '&prompt=login';
	return resetUrl;
};

export default authActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/authActions.ts